const apiUrl = process.env.REACT_APP_API_URL;

export const getInventory = async (
    categories = [],
    locations = [],
    statuses = [],
    qty = { min: null, max: null },
    stages = [],
    q = '',
    date = { field: 'acquisitionDate', from: null, to: null }
) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/inventory/search`;

    const body = {
        categories, locations, statuses,
        stages,                          // ['raw','processing'] o ids
        qtyMin: qty?.min ?? null,
        qtyMax: qty?.max ?? null,
        q,
        dateField: date?.field ?? 'acquisitionDate',
        dateFrom: date?.from ?? null,
        dateTo: date?.to ?? null,
    };

    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(body)
    });

    if (!res.ok) return [];
    return await res.json();
};

export const getItem = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/getItem/${id}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {};
    }
};

export const getLogs = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/getLogs/${id}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return [];
    }
};

export const startProcess = async (itemId, { quantity, date, notes }) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/start`;
    const body = { itemId, quantity, date, notes };

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body),
    });

    if (!res.ok) throw new Error('startProcess failed');
    return res.json();
};

/** Finalizar proceso: processing -> finished */
export const finishProcess = async (itemId, { quantity, date, notes }) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/finish`;
    const body = { itemId, quantity, date, notes };

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body),
    });

    if (!res.ok) throw new Error('finishProcess failed');
    return res.json();
};

// services/Items/Inventory.js
export const getMovements = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/${id}/movements`;
    const res = await fetch(url, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return [];
    return res.json();
};

export const getLastReversibleMovement = async (itemId) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${apiUrl}/api/items/${itemId}/last-reversible`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return null;
    return res.json(); // { id, movement_type, quantity, from_stage_id, to_stage_id, ... } | null
};

export const undoMovement = async (movementId) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${apiUrl}/api/process/undo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ movementId })
    });
    return res.json(); // { result: true, reversedId } | { result:false, message }
};

// RAW -> PROCESSING (con sub-etapa)
export const startProcessWithStep = async (itemId, payload) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${apiUrl}/api/process/${itemId}/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(payload)
    });

    if (!res.ok) {
        let msg = 'No se pudo iniciar el proceso';
        try { const j = await res.json(); msg = j?.message || msg; } catch { }
        throw new Error(msg);
    }

    return res.json(); // { result: true, reversedId } | { result:false, message }
};

// PROCESSING(stepFrom) -> PROCESSING(stepTo)
export const advanceProcessStep = async (itemId, payload) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${apiUrl}/api/process/${itemId}/advance`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(payload)
    });

    if (!res.ok) {
        let msg = 'No se pudo avanzar con el proceso';
        try { const j = await res.json(); msg = j?.message || msg; } catch { }
        throw new Error(msg);
    }

    return res.json();
};

// PROCESSING(stepFrom) -> FINISHED (con conversión)
export const finishProcessWithConversion = async (itemId, payload) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${apiUrl}/api/process/${itemId}/finish`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(payload)
    });

    if (!res.ok) {
        let msg = 'No se pudo finalizar el proceso';
        try { const j = await res.json(); msg = j?.message || msg; } catch { }
        throw new Error(msg);
    }

    return res.json();
};

export const getFullHistory = async (itemId) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${apiUrl}/api/items/${itemId}/history`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return { items: [], movements: [] };
    return res.json();
};

export async function assignFolios(toItemId, body) {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/${toItemId}/assignFolios`;

    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(body)
    });

    let json = null;
    try { json = await res.json(); } catch { }

    if (!res.ok || json?.result === false) {
        const msg = json?.message || 'No se pudo asignar folios';
        throw new Error(msg);
    }
    return json;
};

export async function getItemFolioRanges(itemId) {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/${itemId}/folioRanges`;
    const res = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } });
    try { return await res.json(); } catch { return []; }
};

export async function registerOutput(itemId, payload) {
    const token = sessionStorage.getItem('token');

    const res = await fetch(`${apiUrl}/api/items/${itemId}/output`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json?.result === false) {
        throw new Error(json?.message || 'No se pudo registrar la salida');
    }

    return json;
};